import React from 'react'
import './Pricing.scss'

function Pricing() {
  return (
    <div id='pricing'>
        <div className='sectionHeader'>
            <h2 className='sectionTitle'>Pricing</h2>
            <p className='sectionSubtitle'>Frequently Asked Questions</p>
        </div>
        <div className='pricingGrid'>
            <div className='priceCard'>
                <h2>Basic Plan</h2>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Amount</h3>
                    <h2>2GB / $40</h2>
                </div>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Expires in 30 days</h3>
                </div>
                <button className='btn generateButton text-nowrap' style={{marginTop: 10}}>Purchase Data</button>
            </div>
            <div className='priceCard'>
                <h2>Basic Plan</h2>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Amount</h3>
                    <h2>2GB / $40</h2>
                </div>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Expires in 30 days</h3>
                </div>
                <button className='btn generateButton text-nowrap' style={{marginTop: 10}}>Purchase Data</button>
            </div>
            <div className='priceCard'>
                <h2>Basic Plan</h2>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Amount</h3>
                    <h2>2GB / $40</h2>
                </div>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Expires in 30 days</h3>
                </div>
                <button className='btn generateButton text-nowrap' style={{marginTop: 10}}>Purchase Data</button>
            </div>
            <div className='priceCard'>
                <h2>Basic Plan</h2>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Amount</h3>
                    <h2>2GB / $40</h2>
                </div>
                <div className='textContainer'>
                    <h3 style={{color: '#A8A8A8'}}>Expires in 30 days</h3>
                </div>
                <button className='btn generateButton text-nowrap' style={{marginTop: 10}}>Purchase Data</button>
            </div>
        </div>
    </div>
  )
}

export default Pricing